import { useState } from 'react';
import axios from 'axios';
import { logError } from '@/utils/logger';
import { submitErrorMessage } from '@/utils/submitError';
import { bt } from '@/i18n/bookingI18n';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useManagedBooking(lang = 'en') {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [bookingRef, setBookingRef] = useState('');
  const [error, setError] = useState('');

  const submit = async (payload) => {
    setSubmitting(true);
    setError('');
    try {
      const res = await axios.post(`${API}/bookings`, payload);
      setBookingRef(res.data.reference);
      setSubmitted(true);
      return true;
    } catch (err) {
      logError('ManagedBooking', err);
      setError(submitErrorMessage(err, bt(lang, 'submitFallback'), lang));
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  const reset = () => { setSubmitted(false); setBookingRef(''); setError(''); };
  return { submit, submitting, submitted, bookingRef, error, reset };
}
